var ValueJS = ValueJS || {};

ValueJS.BootstrapToast = function() {

    var _selector = {
        container : '.toast-container'
    }

    var _initialized = false;

    var _container;


    var _create = function(content) {
        // init on first use
        if (!_initialized) {
            _container = $(_selector.container);
            _initialized = true;
        }
        // toast html
        let output = '';
        // output += '<div class="position-fixed top-0 end-0 p-3" style="z-index: 11">'
            output += '<div class="toast bg-dark text-light" role="alert" aria-live="assertive" aria-atomic="true">';
                // output += '<div class="toast-header">';
                //     output += '<strong class="me-auto">Update</strong>';
                //     output += '<small>just now</small>'
                //     output += '<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>'
                // output += '</div>';
                output += '<div class="toast-body">' + content + '</div>'
            output += '</div>';
        // output += '</div>';
        _container.append(output);
        // check if container is hidden
        if (_container.hasClass('d-none')) {
            _container.removeClass('d-none');
        }
        // enable and shop toast
        let el = $('.toast').last();
        let toast = new bootstrap.Toast(el[0]);
        toast.show();
        // dispose and destroy toast after hide
        el.on('hidden.bs.toast', function() {
            el.remove();
            // check if container should be hidden
            if (_container.is(':empty')){
                _container.addClass('d-none');
            }
        });
    }

    /** PUBLIC API **/
    return {
        create : function(content) {return _create(content);}
    };

}();
